<script lang="ts">
    import { openModal } from 'svelte-modals';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { z } from 'zod';
    import { Job } from './Job';
    import { type JobResponseType } from './types';
    import { BalloonContentGenerator } from './BalloonContentGenerator';
    import IconDropdown from '../../shared/Icons/IconDropdown.svelte';
    import IconDropup from '../../shared/Icons/IconDropup.svelte';
    import { tick } from 'svelte';

    export let jobId: number;
    export let expanded: boolean = false;
    export let job: JobResponseType;

    let balloonContentGenerator: BalloonContentGenerator;
    let html: string;

    function toggle() {
        expanded = !expanded
    }

    $: {
        expanded = expanded;
        balloonContentGenerator = new BalloonContentGenerator(new Job().set(job));
        html = balloonContentGenerator.getBalloonHtmlArray({containerId: 'job_all_attributes_'+job.id, sections: {id: false, address: false}}).join('');
        tick().then(() => {
            balloonContentGenerator.connectBalloonThumbnails('job_all_attributes_'+job.id);
        });

    }
</script>

<div class="container" id="job_all_attributes_{job.id}">
    {#if expanded}
        <div class="header" on:click={toggle}><IconDropup scale={0.75}/> {$_('Job_hide_all_attributes')}</div>
        <div class="attributes">
            {@html html}
        </div>
    {:else}
        <div class="header" on:click={toggle}><IconDropdown scale={0.75}/> {$_('Job_show_all_attributes')}</div>
    {/if}
</div>

<style>
    .container {
        user-select: text;
        cursor: auto;
    }
    .header {
        display: flex;
        align-items: center;
        gap: 5px;
        margin: 10px 0;
        color: var(--automapa-blue);
        cursor: pointer;
    }
    .attributes {
        margin-left: 27px;
    }
</style>
